import { render, staticRenderFns } from "./PaymentCompleted.vue?vue&type=template&id=12e0bef1"
import script from "./PaymentCompleted.vue?vue&type=script&lang=js"
export * from "./PaymentCompleted.vue?vue&type=script&lang=js"
import style0 from "./PaymentCompleted.vue?vue&type=style&index=0&id=12e0bef1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports